import type PointerEventsAutoStyles from './types';

const pointerEventsAuto: PointerEventsAutoStyles = {
    pointerEvents: 'auto',
};

export default pointerEventsAuto;
